import { useCallback } from 'react';

import { IconButton, TableBody, TableCell, TableRow } from '@mui/material';

import {
  ActionInterface,
  ColumnInterface,
  GenericObjectWithActions,
} from '@app/components/common/Table/DefaultTable/types';

import { RowCell } from '../RowCell';

export interface CustomActionPerRowTableBodyProps {
  columns: ColumnInterface[];
  rowsWithActions: GenericObjectWithActions[] | undefined;
  rowKey: string;
}

export const CustomActionPerRowTableBody = ({
  columns,
  rowsWithActions: rows,
  rowKey,
}: CustomActionPerRowTableBodyProps) => {
  /**
   * Helper method to give data-cy label to component for cypress tests
   */
  const getIndex = useCallback(
    (index: number) => {
      if (!rows?.length) return index;
      return index === rows?.length - 1 ? 'last' : index;
    },
    [rows]
  );

  return (
    <TableBody>
      {rows &&
        rows?.length &&
        rows.map((row: GenericObjectWithActions, index: number) => (
          <TableRow data-cy={`row-${getIndex(index)}`} key={row[rowKey] as number | string} sx={{ height: 53 }}>
            {columns.map((column: ColumnInterface) => (
              <RowCell key={column.key} row={row} column={column} />
            ))}

            <TableCell sx={{ minWidth: 112 }} align="right">
              {row.actions &&
                row.actions.map((action: ActionInterface) => (
                  <IconButton
                    data-cy={`row-${getIndex(index)}-${action.id}`}
                    key={action.id}
                    onClick={() => action.action(row)}>
                    <action.icon />
                  </IconButton>
                ))}
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  );
};
